// Enhancements delegate all purchases and media activation to Dawn.
if (!customElements.get('zenutra-gallery-dots')) {
  customElements.define('zenutra-gallery-dots', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.parentElement.querySelector('media-gallery');
      this.viewer = this.gallery?.querySelector('slider-component');
      this.list = this.gallery?.querySelector('.product__media-list');
      if (!this.list) return;
      this.onSlide = event => {
        const item = event.detail.currentElement;
        if (!item) return;
        this.select(item.dataset.mediaId);
        // A swipe must update accessibility without snapping/reordering the carousel.
        if (!item.classList.contains('is-active')) {
          this.list.querySelectorAll('[data-media-id]').forEach(media => media.classList.toggle('is-active', media === item));
          const thumbnail = this.gallery.elements.thumbnails?.querySelector(`[data-target="${item.dataset.mediaId}"]`);
          if (thumbnail) {
            this.gallery.setActiveThumbnail(thumbnail);
            this.gallery.announceLiveRegion(item, thumbnail.dataset.mediaPosition);
          }
        }
      };
      this.viewer?.addEventListener('slideChanged', this.onSlide);
      this.observer = new MutationObserver(() => this.build());
      this.observer.observe(this.list, { childList: true });
      this.build();
    }
    build() {
      this.replaceChildren();
      const media = [...this.list.querySelectorAll('[data-media-id]')].filter(item => item.clientWidth > 0);
      if (media.length < 2) return;
      media.forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.mediaId = item.dataset.mediaId;
        button.setAttribute('aria-label', `View media ${index + 1}`);
        button.addEventListener('click', () => {
          this.gallery.setActiveMedia(item.dataset.mediaId, false);
          this.select(item.dataset.mediaId);
        });
        this.append(button);
      });
      this.select(this.list.querySelector('.is-active')?.dataset.mediaId || media[0].dataset.mediaId);
    }
    select(id) {
      this.querySelectorAll('button').forEach(button => button.setAttribute('aria-current', String(button.dataset.mediaId === id)));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.viewer?.removeEventListener('slideChanged', this.onSlide);
    }
  });
}

if (!customElements.get('zenutra-pdp-sticky')) {
  customElements.define('zenutra-pdp-sticky', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.footer = document.querySelector('.zenutra-footer');
      this.button = this.querySelector('button');
      this.price = this.querySelector('.zenutra-pdp-sticky__price');
      this.mobile = matchMedia('(max-width: 749px)');
      if (!this.main || !this.footer) return;
      this.onClick = () => this.main.querySelector('.product-form__submit')?.click();
      this.button.addEventListener('click', this.onClick);
      this.sync = this.sync.bind(this);
      this.mobile.addEventListener('change', this.sync);
      this.purchaseObserver = new IntersectionObserver(this.sync);
      const rootStyle = getComputedStyle(document.documentElement);
      const nearFooter = parseFloat(rootStyle.getPropertyValue('--space-9')) * parseFloat(rootStyle.fontSize);
      this.footerObserver = new IntersectionObserver(entries => {
        this.nearFooter = entries[0].isIntersecting;
        this.sync();
      }, { rootMargin: `0px 0px ${nearFooter}px 0px` });
      this.footerObserver.observe(this.footer);
      this.contentObserver = new MutationObserver(this.sync);
      this.contentObserver.observe(this.main, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy', 'class'] });
      this.sync();
    }
    sync() {
      const mainButton = this.main.querySelector('.product-form__submit');
      if (!mainButton) { this.hidden = true; return; }
      if (this.observedButton !== mainButton) {
        this.purchaseObserver.disconnect();
        this.purchaseObserver.observe(mainButton);
        this.observedButton = mainButton;
      }
      this.button.disabled = mainButton.disabled;
      this.button.setAttribute('aria-busy', String(mainButton.getAttribute('aria-busy') === 'true'));
      this.button.textContent = mainButton.querySelector('span')?.textContent.trim() || mainButton.textContent.trim();
      const priceRoot = this.main.querySelector('[id^="price-"] .price');
      const price = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item');
      if (price) this.price.textContent = price.textContent.trim();
      this.hidden = !this.mobile.matches || mainButton.getBoundingClientRect().bottom >= 0 || Boolean(this.nearFooter);
    }
    disconnectedCallback() {
      this.purchaseObserver?.disconnect();
      this.footerObserver?.disconnect();
      this.contentObserver?.disconnect();
      this.mobile?.removeEventListener('change', this.sync);
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
